import { GlassPanelFrame } from "@ui-kit/GlassPanel";
import type { PanelId } from "../../../types/FloatingPanelTypes";
import { PanelContent } from "./PanelContent";
import { PanelHeader, type PanelHeaderDragProps } from "./PanelHeader";

type PanelBodyProps = {
	id: PanelId;
	title: string;
	onClose: () => void;
	drag?: PanelHeaderDragProps;
	action: React.ReactNode;
};

export const PanelBody = ({ id, title, onClose, drag, action }: PanelBodyProps) => {
	return (
		<GlassPanelFrame
			aria-label={title}
			className="absolute inset-0"
			header={<PanelHeader action={action} drag={drag} id={id} onClose={onClose} title={title} />}
			role="dialog"
		>
			<PanelContent id={id} />
		</GlassPanelFrame>
	);
};
